export default __webpack_public_path__ + "e5077cb8eeee23dcdb69cc1c3686a439.png";